import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PseComponent } from './pages/pse/pse.component';

const routes: Routes = [
  {
    path: 'pse',
    component: PseComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CallbacksRoutingModule { }
